import script from "./StepSetPasswordFromLink.vue?vue&type=script&setup=true&lang=js"
export * from "./StepSetPasswordFromLink.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__